import React from 'react'
import {CHECKOUT2_PARTICIPANTS_FORMDATA, CHECKOUT2_PARTICIPANTS_COUNT_INCREMENT, CHECKOUT2_PARTICIPANTS_COUNT_DECREMENT, CHECKOUT2_PARTICIPANTS_COUNT_INITIAL, CHECKOUT2_CUSTOMERAS_PARTICIPANTS_FORMDATA,CHECKOUT2_PARTICIPANTS_FORMDATA_CLEAR} from '../../../checkout/constantTypes/checkout2/participantsConstantTypes'
import { getPartcipantModel } from '../../../../models/ViewModel';


const initialState=getPartcipantModel(1)  ;

export const ParticipantsReducer=(state=initialState,action)=> {
    let payload=action.payload|| undefined;
    if(payload===undefined || payload===null || payload===0){
        payload={participants:initialState};
    }
    switch (action.type) {
        case CHECKOUT2_PARTICIPANTS_FORMDATA:
       
            return {   ...state,participants:payload}
            case CHECKOUT2_PARTICIPANTS_FORMDATA_CLEAR:
       
                return {   ...state,participants:initialState}
                  
               
              
        default: return state;
            
    }
}


export const CustomerAsParticipantsReducer=(state=[],action)=> {
    switch (action.type) {
        case CHECKOUT2_CUSTOMERAS_PARTICIPANTS_FORMDATA:
       
            return {   ...state,customerasparticipants:action.payload}
               
              
        default: return state;
            
    }
}

export const CapacityReducer=(state=1,action)=> {
   
    switch (action.type) {
        case CHECKOUT2_PARTICIPANTS_COUNT_INCREMENT:
                
       
            return {   ...state,capacity:action.payload+1}
            case CHECKOUT2_PARTICIPANTS_COUNT_DECREMENT:
              
             
            return {   ...state,capacity:action.payload-1}
            case    CHECKOUT2_PARTICIPANTS_COUNT_INITIAL:
                return {   ...state,capacity:action.payload}
        default:return state
            
    }
}


